// extracted by mini-css-extract-plugin
export default {"breit":"style_breit__vKQZL","spaltenOben":"style_spaltenOben__Gfnnv","spalte":"style_spalte__KWV2A"};